import React from 'react'
import { node, shape } from 'prop-types'
import ThemeConsumer from '../ThemeConsumer'

const Form = ({ theme, children, ...rest }) => (
  <form className={theme.normal} {...rest} noValidate>
    {children}
  </form>
)

Form.propTypes = {
  theme: shape({}),
  children: node,
}

Form.defaultProps = {
  theme: {},
  children: null,
}

export default ThemeConsumer('UIForm')(Form)



// WEBPACK FOOTER //
// ./src/shared/components/Form/index.js